import React, { useState } from 'react';
import PageInstructions from '@shared/components/PageInstructions';
import { Page } from '../../layout';
import { Breadcrumb } from '../../shared/components/breadcrumb/Breadcrumb';
import { useQuery } from '@apollo/client';
import GET_INVOICES from '../queries/getInvoicesQuery';
import ApolloError from '@shared/components/ApolloError';
import InvoicesTable from './InvoicesTable';
import InvoicesMapper from '../mappers/InvoicesMapper';
import { AnimatePresence } from 'framer-motion';
import AnimatedWrapper from '@shared/components/animations/AnimatedWrapper';
import LinkButton from '@shared/components/LinkButton';

const PAGE_NUMBER = 1;
const PAGE_SIZE = 10;

const TITLE = 'Invoices';
const DESCRIPTION =
  'This report provides the Organization and Organizational Unit Invoices. Results are in reverse chronological order. ' +
  'Headers can be used to filter results. A red bubble in the due date column indicates a past due invoice.';

const InvoicesPage = () => {
  const breadcrumbPathItems = [{ name: TITLE, url: '' }];

  const [pageNumber, setPageNumber] = useState(PAGE_NUMBER);
  const [limit, setLimit] = useState(PAGE_SIZE);

  const { data, loading, error } = useQuery(GET_INVOICES, {
    variables: {
      pageNumber,
      limit
    }
  });

  const viewPayInvoiceUrl = data?.invoices?.ViewPayInvoiceUrl;
  const totalCount = data?.invoices?.TotalCount;
  const tableData = InvoicesMapper.toTableData(data?.invoices?.Invoices || []);

  const handleChange = (pageNumber, pageLimit) => {
    setPageNumber(pageNumber);
    setLimit(pageLimit);
  };

  if (error) {
    return <ApolloError />;
  }

  return (
    <Page title={TITLE} className='invoices-page'>
      <Breadcrumb pathItems={breadcrumbPathItems}>
        <AnimatePresence mode='wait'>
          <AnimatedWrapper
            show={!!viewPayInvoiceUrl}
            as={LinkButton}
            to={viewPayInvoiceUrl}
            target='_blank'
            rel='noopener noreferrer'
            className='view-pay-invoice-btn primary-button sm'>
            View / Pay Invoice
          </AnimatedWrapper>
        </AnimatePresence>
      </Breadcrumb>
      <PageInstructions title={TITLE} description={DESCRIPTION} />
      <InvoicesTable
        loading={loading}
        data={tableData}
        totalCount={totalCount}
        pageSize={limit}
        pageNumber={pageNumber}
        handleChange={handleChange}
      />
    </Page>
  );
};

export default InvoicesPage;
